module.exports = __webpack_public_path__ + "img/icon-pinterest.c557c3d4.svg";